module.exports = __webpack_public_path__ + "5c114213/img/verified-icon.f93bbc14.svg";